module.exports = "/img/logo-futebol.png?da15d44238d17a0f604343d42615e60e";


//////////////////
// WEBPACK FOOTER
// ./resources/assets/img/identity/logo-futebol.png
// module id = MX3p
// module chunks = 60